import { z } from 'zod';

/** Money arrives as a decimal string (decimal.StringFixed(2)); validate the shape. */
export const moneyString = z
  .string()
  .regex(/^-?\d+\.\d{2}$/, 'expected a decimal money string, e.g. "12.34"');

/** ISO/RFC3339 or YYYY-MM-DD date string. Kept permissive on purpose. */
export const timestamp = z.string();

/**
 * A response array that tolerates a null/absent wire value (Go serializes an
 * empty/nil slice as JSON null) by coercing it to []. The inferred type stays
 * T[], so consumers always get an array.
 */
export function nullableArray<T extends z.ZodTypeAny>(item: T) {
  return z
    .array(item)
    .nullish()
    .transform((v) => v ?? []);
}

/** Wraps a paginated list response: { data, total, page, limit }. */
export function paginated<T extends z.ZodTypeAny>(item: T) {
  return z.object({
    data: nullableArray(item),
    total: z.number(),
    page: z.number(),
    limit: z.number(),
  });
}

// Enum primitives mirroring the union-literal types in types/api.ts.
export const householdItemType = z.enum(['list_item', 'chore', 'task']);
export const householdItemState = z.enum(['open', 'done']);
export const householdItemRecurrence = z.enum(['daily', 'weekly', 'monthly', 'yearly']);
export const listKind = z.enum(['generic', 'groceries']);
export const investmentType = z.enum(['fixed', 'variable']);
export const categoryConfidence = z.enum(['exact', 'fuzzy']);
